/**
 * Huy hiệu "MỚI" ở menu và tiêu đề màn (QUYET-DINH S10): bật 30 ngày sau khi go live rồi tắt
 * bằng cấu hình, không sửa code. `VITE_NEW_BADGES_UNTIL` nhận ngày `YYYY-MM-DD` (tự tắt sau ngày đó)
 * hoặc `off` (tắt ngay); để trống là bật.
 */
const until = import.meta.env.VITE_NEW_BADGES_UNTIL?.trim();
export const SHOW_NEW_BADGES =
  until === "off"
    ? false
    : !until ||
      Number.isNaN(Date.parse(until)) ||
      Date.now() <= Date.parse(`${until}T23:59:59+07:00`);
export function NewBadge() {
  return SHOW_NEW_BADGES ? <span className="newbadge">mới</span> : null;
}
